import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/founder/stores")({
    component: RouteComponent,
});

function RouteComponent() {
    return <Outlet />;
}
